import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import Helmet from 'react-helmet';

function SharedHeadScriptTagsComponent({ metadata }) {
    const scriptTagsArray = [];

    const { microdata } = metadata;
    if (microdata) {
        scriptTagsArray.push({
            type: 'application/ld+json',
            innerHTML: microdata,
        });
    }

    return <Helmet script={scriptTagsArray} />;
}

SharedHeadScriptTagsComponent.propTypes = {
    metadata: PropTypes.object.isRequired,
};

export const SharedHeadScriptTags = createFragmentContainer(SharedHeadScriptTagsComponent, {
    metadata: graphql`
        fragment SharedHeadScriptTags_metadata on MetaData {
            microdata
        }
    `,
});
